import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import NotFound from "../../features/errors/NotFound";
import ServerError from "../../features/errors/ServerError";
import Profile from "../../features/account/Index";
import RequireAuth from "./RequireAuth";
import DashboardLayout from "../layout/Dashboard";
import AuthLayout from "../layout/Auth";
import Root from "../layout/Root";
import CategoryPage from "../../features/category/categoryList";
import UpdateCategory from "../../features/category/updateCategory";
import ProductList from "../../features/product/productList";
import AddProduct from "../../features/product/addproduct";
import AddOrganisation from "../../features/organisationOnboard/AddOrganisation";
import OrderManagement from "../../features/orderManagement";
import OrganisationList from "../../features/organisationOnboard/OrganisationList";
import SubCategoryList from "../../features/subCategory/subCategoryList";
import DashboardHome from "../../features/dashboard";
import UpdateProduct from "../../features/product/updateProduct";
import OutletList from "../../features/outlet/OutletList";
import AddOutlet from "../../features/outlet/addOutlet";
import ComingSoon2 from "../../features/overview";
import AddCategory from "../../features/category/addCategory";
import UserList from "../../features/users/UserList";
import AddOutletUser from "../../features/users/addUser";
import CustomProduct from "../../features/product/CustomProduct";
import AddSubCategory from "../../features/subCategory/SubCategoryAdd";
import SubCategoryUpdate from "../../features/subCategory/subCategoryUpdate";
import GetOrdersData from "../../features/orderManagement/getOrdersData";
import UpdateOrganisation from "../../features/organisationOnboard/updateOrganisation";
import UpdateOutlet from "../../features/outlet/updateOutlet";
import UpdateOutletUser from "../../features/users/updateUser";
import CreateSalesReturn from "../../features/orderManagement/createSalesReturn";
import SalesReturnList from "../../features/orderManagement/SalesReturnList";
import PodList from "../../features/orderManagement/PODList";
import GetPODData from "../../features/orderManagement/getPODData";
import CreditNotesList from "../../features/orderManagement/CreditNotes";

//test
export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Root />,
    children: [
      {
        element: <DashboardLayout />,
        children: [
           { index: true, element: <Navigate to="/login" replace /> }, //  Add this line
          {
            element: <RequireAuth />,
            children: [
              { path: "dashboard", element: <DashboardHome /> },
              { path: "profile", element: <Profile /> },
              {
                path: "catalog",
                children: [
                  {
                    path: "category",
                    children: [
                      { index: true, element: <CategoryPage /> },
                      { path: "add", element: <AddCategory /> },
                      { path: ":id", element: <UpdateCategory /> },
                    ],
                  },
                  {
                    path: "subcategory",
                    children: [
                      { index: true, element: <SubCategoryList /> },
                      { path: "add", element: <AddSubCategory /> },
                      { path: "update/:id", element: <SubCategoryUpdate /> },
                    ],
                  },
                 
                  {
                    path: "product",
                    children: [
                      { index: true, element: <ProductList /> },
                      { path: "add", element: <AddProduct /> },
                      { path: "update/:id", element: <UpdateProduct /> },
                    ],
                  },
                  {
                    path: "product/custom",
                    children: [
                      { index: true, element: <CustomProduct /> },
                      { path: "add", element: <AddProduct /> },
                      { path: "update/:id", element: <UpdateProduct /> },
                    ],
                  },
                  {
                    path: "stock-management",
                    children: [
                     
                      { index:true, element: <ComingSoon2 /> },
                     
                    ],
                  },


                ],
              },
              {
                path: "Orders",
                children: [
                  { index: true, element: <OrderManagement /> },
                  { path: ":id", element: <GetOrdersData/> },
                  { path: "sales-return", element: <SalesReturnList/> },
                  { path: "sales-return/:id", element: <CreateSalesReturn/> },
                  { path: "credit-notes", element: <CreditNotesList/> },
                  { path: "credit-notes/:id", element: <GetPODData/> },
                  { path: "pod", element: <PodList/> },
                  { path: "pod/:id", element: <GetPODData/> },

                ],
              },
              {
                path: "organisation",
                children: [
                  { index: true, element: <OrganisationList /> },
                  { path: "add", element: <AddOrganisation /> },
                  { path: "outlet", element: <OutletList /> },
                  { path: "outlet/add", element: <AddOutlet /> },
                  { path: "outlet/user", element: <UserList /> },
                  { path: "outlet/user/add", element: <AddOutletUser /> },
                  { path: "update/:id", element: <UpdateOrganisation /> },
                  { path: "outlet/update/:id", element: <UpdateOutlet /> },
                  { path: "outlet/user/update/:id", element: <UpdateOutletUser /> },
                ],
              },
            ],
          },
          { path: "not-found", element: <NotFound /> },
          { path: "server-error", element: <ServerError /> },
          { path: "*", element: <Navigate replace to="/not-found" /> },
        ],
      },
      { path: "login", element: <AuthLayout /> },
    ],
  },
];


export const router = createBrowserRouter(routes);
